// This is a way to find the typeahead input element that corresponds to the popup element
// that is passed in
angular.module('aprima-core-ui').factory('findTypeahead', ['$document', function($document) {
    'use strict';

    return findTypeaheadElementFromPopup;
    
    function findTypeaheadElementFromPopup(popupElement) {
        if(!popupElement || !popupElement[0]) {
            return;
        }

        return $document.find('[aria-owns="' + popupElement[0].id + '"]');
    }
}]);